import { FOOD_SIPSA_SOURCE_KEYS } from "../../../../constants/foodSourceConstants";

export const SIPSA_INGESTION_HREF_BY_SOURCE = Object.freeze({
  [FOOD_SIPSA_SOURCE_KEYS.WHOLESALE]: "#/admin/food-wholesale-ingestion",
  [FOOD_SIPSA_SOURCE_KEYS.SUPPLY]: "#/admin/food-supply-ingestion",
  [FOOD_SIPSA_SOURCE_KEYS.INPUTS]: "#/admin/food-input-ingestion",
});

export function getSipsaIngestionHref(sourceKey) {
  return SIPSA_INGESTION_HREF_BY_SOURCE[sourceKey] || "#/admin/food-wholesale-ingestion";
}

export function parseSipsaIngestionApiError(error) {
  if (!error) {
    return "SIPSA request failed.";
  }

  if (typeof error === "string") {
    return error;
  }

  if (error.message) {
    return error.message;
  }

  return "SIPSA request failed.";
}

export function getSipsaRunResultMessage(result) {
  if (!result) {
    return null;
  }

  const ingestion = result.ingestion || result;
  const inserted =
    ingestion.observationsInserted ??
    ingestion.recordsParsed ??
    ingestion.volumeNormalized ??
    0;
  const status = ingestion.status || (result.success ? "completed" : "error");
  const mockNote = result.useMock ? " (mock data)" : "";

  let message = `SIPSA ingestion ${status}: ${inserted} records${mockNote}.`;

  if (result.trends?.trendsCalculated != null) {
    message += ` Trends: ${result.trends.trendsCalculated}.`;
  }

  return message;
}
